export default {
  metadata: {
    version: '1.0.0',
    id: 'selector-item-1.0.0',
    name: 'JDSSelectorItem'
  },
  hierarchy: {
    container: ['icon', 'jds-text']
  },
  base: {
    container: {
      opacity: '{s_0}',
      'background-color': '{s_1}',
      'flex-direction': '{s_2}',
      'align-items': '{s_3}',
      'justify-content': '{s_4}',
      'border-radius': '{s_5}',
      gap: '{s_6}',
      'padding-top': '{s_7}',
      'padding-right': '{s_8}',
      'padding-bottom': '{s_9}',
      'padding-left': '{s_10}',
      behavior: {
        focus: {
          'background-color': '{s_11}',
          'box-shadow': {
            x: 0,
            y: 0,
            blur: 0,
            spread: '{s_12}',
            color: '{s_13}'
          }
        },
        hover: {
          'background-color': '{s_14}'
        },
        active: {
          'background-color': '{s_15}'
        }
      }
    },
    icon: {
      size: '{s_16}',
      color: '{s_17}',
      hidden: false
    },
    'jds-text': {
      'font-family': '{text_132}',
      color: '{text_13}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    selected: {
      true: {
        container: {
          behavior: {
            hover: {
              'background-color': '{s_19}'
            },
            active: {
              'background-color': '{s_20}'
            },
            focus: {
              'background-color': '{s_21}'
            }
          }
        },
        icon: {
          color: '{s_22}',
          behavior: {
            active: {
              color: '{s_23}'
            }
          }
        },
        'jds-text': {
          color: '{text_18}',
          behavior: {
            hover: {},
            active: {
              color: '{text_16}'
            }
          }
        }
      }
    },
    kind: {
      label: {
        icon: {
          hidden: true
        }
      },
      icon: {
        'jds-text': {
          hidden: true
        }
      }
    },
    wrap: {
      vertical: {
        container: {
          'flex-direction': '{s_24}',
          gap: '{s_27}'
        }
      }
    },
    stretch: {
      true: {
        container: {
          width: '{s_25}'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{s_26}'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      selected: {
        values: [false, true]
      },
      stretch: {
        values: [false, true]
      },
      kind: {
        values: ['label_icon', 'label', 'icon']
      },
      wrap: {
        values: ['horizontal', 'vertical']
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      icon: {
        value: {
          type: 'icon',
          name: 'icon'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    events: {
      container: {
        onAppear: {
          name: 'onAppear',
          platform: 'ios, android'
        },
        onClick: 'onClick',
        onFocus: {
          name: 'onFocus',
          platform: 'web'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'radio'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-checked': {
            name: '_ariaChecked',
            prop: 'selected'
          }
        }
      },
      icon: {
        properties: {
          role: {
            value: 'img'
          },
          'aria-label': {
            name: 'iconAriaLabel',
            function: true
          }
        }
      }
    }
  }
};
